import types from './types'
import auth from './auth'
import contacts from './contacts'
import search from './search'
import snackbar from './snackbar'
import state from './state'
import pivotTable from './pivotTable'
import dirty from './dirty'
import dialog from './dialog'
import notifications from './notifications'
import onboarding from './onboarding'

import { errors } from '../config/strings'

const syncWithRoute = (context) => ({ type: types.SYNC_WITH_ROUTE, context })

const generalError = (message = errors.GENERAL_ERROR, code = 0) => ({ type: types.GENERAL_ERROR, message, code })

export {
  syncWithRoute,
  generalError,
  state,
  auth,
  contacts,
  snackbar,
  search,
  pivotTable,
  dirty,
  dialog,
  notifications,
  onboarding,
}
